import MainDashboard from "../mis/pages/MainDashboard";

const LandingPage = () => <MainDashboard />;

export default LandingPage;
